import { useTranslation } from 'react-i18next';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "";

// Get locale from cookie
const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

// Safely format date
const formatDate = (dateString, locale) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

// Format date + time
const formatDateTime = (dateString, locale) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return `${date.toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  })} ${date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

const ProjectTitle = ({
  title,
  placeName,
  startDate,
  endDate,
  vernissage,
  description,
  entranceCost,
  eventType,
  city,
  country,
  image,
}) => {
  const locale = getLocaleFromCookie();
  const { t } = useTranslation();

  const renderDescription = (desc) => {
    if (!Array.isArray(desc)) return null;
    return desc.map((block, idx) => {
      const text = block?.children?.map((child) => child.text).join(" ") || "";
      return (
        <p key={idx} className="lead text-black" style={{ lineHeight: "1.5" }}>
          {text}
        </p>
      );
    });
  };

  return (
    <div className="container mt-10 mb-10">
      <div className="row justify-content-center">
        <div className="col-12">

          {/* Title */}
          {title && (
            <h1 className="mb-1 text-black" style={{ fontWeight: "bold" }}>
              {title}
            </h1>
          )}

          {/* Image */}
          {image?.url && (
            <img
              src={image.url.startsWith("http") ? image.url : `${STRAPI_URL}${image.url}`}
              alt={image.alternativeText || "Event image"}
              className="col-12 equal equal-1-1 mb-3 mt-2"
              style={{ display: "block" }}
            />
          )}

		  
          {/* Event Info List */}
          <ol className="list-group list-group-separated col-12 mb-4">
            {placeName && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead mt-0 mb-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("events.placeName", "Venue")}
                  </p>
                </span>
                <p className="lead mt-0 mb-0 text-end" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {placeName}
                </p>
              </li>
            )}

            {startDate && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead mt-0 mb-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("events.startDate", "Start")}
                  </p>
                </span>
                <p className="lead mt-0 mb-0 text-end" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {formatDate(startDate, locale)}
                </p>
              </li>
            )}

            {endDate && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead mt-0 mb-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("events.endDate", "End")}
                  </p>
                </span>
                <p className="lead mt-0 mb-0 text-end" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {formatDate(endDate, locale)}
                </p>
              </li>
            )}

            {vernissage && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead mt-0 mb-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("events.vernissage", "Vernissage")}
                  </p>
                </span>
                <p className="lead mt-0 mb-0 text-end" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {formatDateTime(vernissage, locale)}
                </p>
              </li>
            )}

            <li className="list-group-item d-flex justify-content-between align-items-start text-black">
              <span>
                <p className="lead mt-0 mb-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {t("events.price", "Entrance")}
                </p>
              </span>
              <p className="lead mt-0 mb-0 text-end" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                {entranceCost || t("events.freeEntry", "Free")}
              </p>
            </li>

            {eventType && (
              <li className="list-group-item d-flex justify-content-between align-items-start text-black">
                <span>
                  <p className="lead mt-0 mb-0" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                    {t("events.eventType", "Event Type")}
                  </p>
                </span>
                <p className="lead mt-0 mb-0 text-end" style={{ lineHeight: "90%", textTransform: "uppercase" }}>
                  {eventType}
                </p>
              </li>
            )}
          </ol>

          {/* Description */}
          {Array.isArray(description) && description.length > 0 && (
            <>
              <h2 className="mb-1 text-black">{t("events.description", "Synopsis")}</h2>
              {renderDescription(description)}
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default ProjectTitle;
